import * as types from "./actionTypes";
import API from "../../services/EnrollmentService";
import {apiCallError, beginApiCall} from "./apiStatusActions";

export function loadEnrollmentsSuccess(enrollments) {
  return { type: types.LOAD_ENROLLMENTS_SUCCESS, enrollments };
}

export function createEnrollmentSuccess(enrollment) {
  return { type: types.CREATE_ENROLLMENT_SUCCESS, enrollment };
}

export function updateEnrollmentSuccess(enrollment) {
  return { type: types.UPDATE_ENROLLMENT_SUCCESS, enrollment };
}

export function saveEnrollment(enrollment) {
  return (dispatch) => {
    dispatch(beginApiCall('saveEnrollment'));
    return API.saveEnrollment(enrollment)
      .then((savedEnrollment) => {
        dispatch(enrollment.id ? updateEnrollmentSuccess(savedEnrollment) : createEnrollmentSuccess(savedEnrollment));
        return savedEnrollment;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function activatePackageEnrollment(enrollmentId, command) {
  return (dispatch) => {
    dispatch(beginApiCall('activatePackageEnrollment'));
    return API.activatePackageEnrollment(enrollmentId, command)
      .then((savedEnrollment) => {
        dispatch(updateEnrollmentSuccess(savedEnrollment));
        return savedEnrollment;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function extendPackageValidity(enrollmentId, command) {
  return (dispatch) => {
    dispatch(beginApiCall('extendPackageValidity'));
    return API.extendPackageValidity(enrollmentId, command)
      .then((savedEnrollment) => {
        dispatch(updateEnrollmentSuccess(savedEnrollment));
        return savedEnrollment;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadEnrollments() {
  return (dispatch) => {
    dispatch(beginApiCall('getEnrollments'));
    return API.getEnrollments()
      .then((enrollments) => {
        dispatch(loadEnrollmentsSuccess(enrollments));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
